import React, { Dispatch, SetStateAction } from 'react';
import { TeamMembers, teamMemberStatusName } from '../../../../interfaces/User';
import { formatDate } from '../../../../utils/helper';
import { MoreIcon } from '../../../../components/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { Dropdown, MenuProps } from 'antd';

const TeamMembersMobileCard = ({
    item,
    onClick,
    getMenu,
    setSelectedUser
}: {
    item?: TeamMembers;
    onClick?: () => void;
    getMenu: (record: TeamMembers) => MenuProps['items'];
    setSelectedUser: Dispatch<SetStateAction<TeamMembers | null>>;
}) => {
    const { user } = useSelector((state: RootState) => ({
        user: state.user.user
    }));
    const isPending = item?.status === 3;
    const isInactive = item?.status === 2;
    const isCurrentUser = user?.user_id === item?.id;

    return (
        <div
            className='bg-white border-b border-appcolorfaintnine pb-4 mb-6 relative'
            onClick={onClick}
        >
            {!isPending && !isCurrentUser && !isInactive && (
                <div className='absolute top-0 right-0 flex justify-center'>
                    <Dropdown
                        menu={{ items: getMenu(item || ({} as TeamMembers)) }}
                        trigger={['click']}
                        placement='bottomRight'
                    >
                        <div
                            className='flex flex-row justify-center cursor-pointer'
                            onClick={() => setSelectedUser(item || null)}
                        >
                            <MoreIcon color='#98A2B3' />
                        </div>
                    </Dropdown>
                </div>
            )}
            <div>
                <p className='text-sm uppercase font-semibold leading-5 text-ebony mb-[4px]'>
                    <span>{item?.firstName + ' ' + item?.lastName}</span>
                </p>
                <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Email address:{' '}
                        <span className='font-semibold'>{item?.email}</span>
                    </p>
                </div>
                <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Role:{' '}
                        <span className='font-semibold'>{item?.role}</span>
                    </p>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        User Status:{' '}
                        <span className='font-semibold'>
                            {teamMemberStatusName[item?.status || 0]}
                        </span>
                    </p>
                </div>
                <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Last login:{' '}
                        <span className='font-semibold'>
                            {formatDate(item?.lastLoginDate)}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TeamMembersMobileCard;
